import { generatePath } from 'react-router';

const generateUrl = (
  routeTemplate: string,
  pathParams: Record<string, string>,
  queryParams?: Record<string, string>
): string => {
  const basePath = generatePath(routeTemplate, pathParams);
  const queryString = queryParams
    ? Object.entries(queryParams)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&')
    : '';

  return queryString ? `${basePath}?${queryString}` : basePath;
};

export default generateUrl;
